{
  "new": {
    "title": "Save Educator to Shortlist",
    "actions.save": "Save Educator to Shortlist",
    "shortlists.label": "Select a Shortlist",
    "shortlists.empty": "No shortlists found for your criteria",
    "shortlists.create": "New Shortlist",
    "shortlists.placeholder": "New Shortlist Name",
    "shortlists.create.label": "Shortlist Name",
    "shortlists.create.description": "Create a new shortlist to save this educator.",
    "shortlists.existing.label": "Existing Shortlist",
    "shortlists.existing.description": "Select an existing shortlist to save this educator.",
    "shortlists.radiogroup.label": "Shortlist Type"
  }
}
